<div
  class="node phone-node"
  id="{{ node.id }}"
  [ngClass]="{
    isSelected: selected,
    dragging: mode.inNodeDragMode && dragging,
    drag: mode.inNodeDragMode && !mode.inNodeConnectionMode,
    pointer: mode.inNodeConnectionMode,
    error: touchedAndNotSelected && invalid,
    cantBeConnectedTo: mode.inNodeConnectionMode && !canBeConnectedTo
  }"
  [style.top.px]="node.top || 0"
  [style.left.px]="node.left || 20"
  (click)="onNodeClick($event)"
  (mousedown)="onMouseDown($event)"
  (mouseup)="onMouseUp()"
  #nodeElement
>
  <svg-icon [src]="icon"></svg-icon>
  <div [hidden]="!selected" class="node-overlay">
    <div
      class="node-option delete-option"
      (click)="onDeleteNodeSelected($event)"
    >
      <svg-icon src="assets/svg/flows/sidebar/trashcan.svg"></svg-icon>
    </div>
    <div
      class="node-option connector-option"
      [ngClass]="{
        selected: linkOptionSelected
      }"
      (click)="onStartLinkOptionSelected($event)"
    >
      <svg-icon src="assets/svg/flows/sidebar/connect.svg"></svg-icon>
    </div>
  </div>
</div>
